import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { FenstertypPage } from '../fenstertyp/fenstertyp';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from '../../app/app-config';
import { UserserviceProvider } from '../../providers/userservice';


@Component({
  selector: 'page-kunststoffsysteme',
  templateUrl: 'kunststoffsysteme.html',
})
export class KunststoffsystemePage {
private producttype: string;
loading: any;
category_id: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, public storage: Storage, public http: HttpClient, public appConfig: AppConfig, public userService: UserserviceProvider, public loadingCtrl: LoadingController,) {
    
  //  this.storage.get('Produkt').then((val) => {
  //    console.log('Your product is', val);
  //});
  
  this.producttype = this.navParams.get('producttype');
  console.log(this.producttype); 
      this.appConfig.baseURI = 'http://test.lovanet.ch/arenafenster/app_controller/';
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad KunststoffsystemePage');
  } 
  
    clickwindowtype() {
    this.navCtrl.push(FenstertypPage, {
    productname: productname
    });
  }
  
     ionViewWillEnter() : void
   {
      this.getProduct();
   }
  
  getProduct(){
  this.category_id = 1;
  this.presentLoading();
  this.userService.getProducts(this.category_id).subscribe((data : any) =>
      {
          this.items = data;
          console.dir(data);
          this.loading.dismiss();
      },
      (error : any) =>
      {
         console.dir(error);
        this.loading.dismiss();
      });
        }
        

    presentLoading() {

        this.loading = this.loadingCtrl.create({
            content: 'Please wait...'
        });

        this.loading.present();

    }

}




// WEBPACK FOOTER //
// ./src/pages/kunststoffsysteme/kunststoffsysteme.ts